/** One unsent Help question, retained across routes in this tab only. */
export interface HelpDraftScope {
  readonly identity: string;
  readonly generation: number;
}

let activeIdentity: string | null = null;
let activeScope: HelpDraftScope | null = null;
let generation = 0;
let draft = '';

/** Installed by the session owner even while Help is not mounted. */
export function configureHelpDraftScope(identity: string | null): void {
  if (identity === activeIdentity) return;
  draft = '';
  activeIdentity = identity;
  activeScope = identity === null ? null : { identity, generation: ++generation };
}

export function captureHelpDraftScope(identity: string | null): HelpDraftScope | null {
  return identity !== null && identity === activeIdentity ? activeScope : null;
}

export function readHelpDraft(scope: HelpDraftScope | null): string {
  return scope !== null && scope === activeScope ? draft : '';
}

/** A retired component cannot write even if the same account later returns. */
export function writeHelpDraft(scope: HelpDraftScope | null, value: string): void {
  if (scope !== null && scope === activeScope) draft = value;
}
